<script>
    import LoadingSpinner from "../LoadingSpinner.svelte";
    import Reporter from "../../lib/error.js";

    import Select, {Option} from '@smui/select';
    import Icon from '@smui/select/icon/index';
    import HelperText from '@smui/select/helper-text/index';
    import Button, {Group, GroupItem, Label} from '@smui/button';
    import Paper, {Title, Subtitle, Content} from '@smui/paper';

    const options = [
        "DISTRIBUTE_BASED_ON_STOCK_VALUE",
        "DISTRIBUTE_FIXED_NUMBER_OF_STOCKS",
    ];

    export let selectedFieldId = options[0];
    export let selectedField;
    export let label = "Choose stock division strategy";
    export let help = `
        If you choose a Fixed strategy,
        all available company stock will be divided,
        independent of total contribution worth.
        If you choose 'By contribution value',
        stock will be divided relative to contribution sizes,
        up to the maximum available company stock.
        When the total contribution worth exceeds the available company value,
        the Fixed strategy is used instead.
    `;
</script>

<!--TODO: create row of Paper like in WelcomeDialog and mockup designs-->

<Select enhanced variant="outlined" withLeadingIcon bind:value={selectedFieldId} {label} style="width: 100%">
    <span slot="icon"><Icon class="material-icons">work</Icon></span>
    <Option
            value={options[0]}
            selected={selectedFieldId == options[0]}>
        By contribution value
<!--        <strong style="display: block;">Contribution to Stock value</strong>-->
<!--        Distribute available stocks relative to contribution value, until the maximum available company value-->
<!--        is reached, after which the Fixed strategy is used to divide all stocks based on all contribution-->
<!--        values, relative to each other.-->
    </Option>
    <Option
            value={options[1]}
            selected={selectedFieldId == options[1]}>
        Fixed % of stock
<!--    <strong style="display: block;">Fixed number of stocks</strong>-->
<!--    Divide a fixed number of stocks over all contributions, based on their relative values.-->
    </Option>
</Select>

{#if help}
    <HelperText id="helper-text-persistent-c" persistent>{help}</HelperText>
{/if}

<style>
    option {
        text-transform: capitalize;
    }
</style>